class SimpleLightbox {
  constructor(selector = '.lightbox-img') {
    this.selector = selector;
    this.lightboxEl = null;
    this.imgEl = null;
    this.init();
    this.observe();
  }

  init() {
    document.querySelectorAll(this.selector).forEach((img) => {
      if (!img.dataset.lightboxInit) {
        img.dataset.lightboxInit = '1';
        img.addEventListener('click', (e) => {
          e.preventDefault();
          const largeSrc = img.getAttribute('data-src') || img.src;
          this.open(largeSrc, img.alt || '');
        });
      }
    });

    if (!this.lightboxEl) {
      this.createLightbox();
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });
    }
  }

  observe() {
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'childList') {
          m.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              if (node.matches?.(this.selector)) {
                this.init();
              }
              node.querySelectorAll?.(this.selector).forEach(() => this.init());
            }
          });
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  createLightbox() {
    this.lightboxEl = document.createElement('div');
    this.lightboxEl.className = 'simple-lightbox';
    this.lightboxEl.innerHTML = `
        <div class="simple-lightbox__overlay">
        <div class="simple-lightbox__wrapper">
        <img class="simple-lightbox__img" alt="">
        <button class="simple-lightbox__close"><svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
  class="icon icon-close"
>
  <path d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="currentColor"/>
</svg>
</button>
        </div>
        </div>
      `;
    document.body.appendChild(this.lightboxEl);

    this.imgEl = this.lightboxEl.querySelector('.simple-lightbox__img');
    const closeButton = this.lightboxEl.querySelector('.simple-lightbox__close');
    closeButton.addEventListener('click', () => this.close());
    this.lightboxEl.addEventListener('click', (e) => {
      if (e.target.classList.contains('simple-lightbox__overlay') || e.target === this.lightboxEl) {
        this.close();
      }
    });
  }

  open(src, alt) {
    this.imgEl.src = src;
    this.imgEl.alt = alt;
    this.lightboxEl.classList.add('is-active');
  }

  close() {
    this.lightboxEl.classList.remove('is-active');
    this.imgEl.src = '';
    this.imgEl.alt = '';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SimpleLightbox('.lightbox-img');
});
